import * as React from 'react';

function SvgLockFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6V4a4 4 0 00-8 0v2H4a2 2 0 00-2 2v8a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2h-1zm-1.5 0V4a2.5 2.5 0 00-5 0v2h5zm-.5 6a2 2 0 11-4 0 2 2 0 014 0z"
        fill="#8D8D8D"
      />
    </svg>
  );
}

export default SvgLockFilled;
